import m from "./highrise652.mjs";
import t from "./highrise1308.mjs";
function v(a, f, i, u) {
  var d = !i;
  i || (i = {});
  for (var s = -1, e = f.length; ++s < e; ) {
    var n = f[s], r = void 0;
    r === void 0 && (r = a[n]), d ? t(i, n, r) : m(i, n, r);
  }
  return i;
}
export {
  v as default
};
